import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import { Search } from '@wix/wix-ui-icons-common/odeditor';
import React from 'react';
import { useIsMobile } from '../../hooks/useIsMobile';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { useResultsPageContext } from './ResultsPageContext';
import { useResultsSearchBarV4Layouts, V4_SEARCH_BAR_PLACEHOLDER_KEY } from './resultsSearchBarV4Layouts';
import { useStatusSlot } from './StatusSlot';
export const ResultsSearchBar = _ref => {
  let onSearchSubmit = _ref.onSearchSubmit,
    _ref$isWixHpMobile = _ref.isWixHpMobile,
    isWixHpMobile = _ref$isWixHpMobile === void 0 ? false : _ref$isWixHpMobile,
    _ref$showUnassignedDo = _ref.showUnassignedDomainsOnEmptyInput,
    showUnassignedDomainsOnEmptyInput = _ref$showUnassignedDo === void 0 ? false : _ref$showUnassignedDo,
    _ref$compactLayouts = _ref.compactLayouts,
    compactLayouts = _ref$compactLayouts === void 0 ? false : _ref$compactLayouts,
    scrollIntoView = _ref.scrollIntoView;
  const _DomainSearchGateModu = DomainSearchGateModule.internals.useTranslations(),
    t = _DomainSearchGateModu.t;
  const isMobile = useIsMobile();
  const _useResultsPageContex = useResultsPageContext(),
    emptyQueryStatus = _useResultsPageContex.emptyQueryStatus,
    updateUrl = _useResultsPageContex.updateUrl,
    showSearchIcon = _useResultsPageContex.showSearchIcon,
    hideFilterChips = _useResultsPageContex.hideFilterChips;
  const compactDesktopLayouts = useResultsSearchBarV4Layouts();
  const useCompactDesktopLayouts = compactLayouts && !isMobile;
  const isCompactMobile = compactLayouts && isMobile;
  const StatusComponent = useStatusSlot(emptyQueryStatus);
  const mobilePlaceholder = isWixHpMobile ? t('domains_search_gate.anon.results.empty_state.searchbar.placeholder') : t('domains-search-suite-translations-ns:DomainSearch.Mobile.searchInput.placeholder');
  return /*#__PURE__*/React.createElement(DomainSearchSuiteModule.SDK.Components.DomainSearchBar, {
    compact: true,
    scrollIntoView: scrollIntoView,
    showSearchIcon: showSearchIcon && !isMobile,
    submitIcon: isWixHpMobile ? /*#__PURE__*/React.createElement(Box, {
      verticalAlign: "middle",
      align: "center",
      scale: "1.3"
    }, /*#__PURE__*/React.createElement(Search, {
      color: "white"
    })) : isCompactMobile ? /*#__PURE__*/React.createElement(Search, {
      color: "white"
    }) : undefined,
    emphasized: isWixHpMobile,
    hideClearButton: isWixHpMobile || compactLayouts,
    hideFilters: hideFilterChips,
    showOptionsIfEmptyInput: showUnassignedDomainsOnEmptyInput,
    hideUnassignedDomains: !showUnassignedDomainsOnEmptyInput,
    autoFocus: isWixHpMobile,
    useModalToolbar: isMobile,
    multiline: isMobile && !isCompactMobile,
    placeholder: isWixHpMobile ? mobilePlaceholder : compactLayouts ? t(V4_SEARCH_BAR_PLACEHOLDER_KEY) : isMobile ? mobilePlaceholder : undefined,
    onSubmit: filters => {
      updateUrl(filters);
      onSearchSubmit == null || onSearchSubmit(filters);
    },
    onFiltersChange: (key, value) => {
      if (key === 'tlds') {
        DomainSearchSuiteModule.internals.bi.onSelectTld == null || DomainSearchSuiteModule.internals.bi.onSelectTld({
          tld: JSON.stringify(value)
        });
      } else {
        DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
          ctaClick: key,
          value: JSON.stringify(value)
        });
      }
    },
    Layouts: {
      ...(useCompactDesktopLayouts && compactDesktopLayouts),
      StatusComponent
    }
  });
};
//# sourceMappingURL=ResultsSearchBar.js.map